/**
 * Returns true when a form-model config value represents a real,
 * actionable configuration — i.e. it is a non-null, non-empty string.
 *
 * Use this anywhere `authorICMJEModel` or `authorCopyrightModel` is read
 * so that an empty-string value ("") is treated the same as "not configured".
 */
export const isFormConfigured = (model?: string | null): boolean => {
  return Boolean(model && model.trim() !== '');
};
